export const lang = {
  Home: {
    name: "Home",
    BetterMedicalCare:
      '"Better Medical Care" is a comprehensive service that CHG INC. researched and developed for Chinese customers to ' +
      "solve the difficult situation in which the patients get poor medical and regular healthcare. It provides an international" +
      "domestic express lane so the patients can get treated sooner, online and phone call medical consultation service to make " +
      "it easy and convenient for patients, second medical advice from international domestic experts, cancer screening service, " +
      "and health insurance service. There are three versions according to the program setting: Basic, Domestic and Global.",
    InternationalReferral:
      "We work hand in hand with globally well-known medical institutions, create a better treatment plan according to the patient’s condition." +
      " Patients will be treated with advanced medical equipment, technology, and medicine sooner so the cure rate greatly increases, and they can be more hopeful and relieved." +
      " What’s more, we also provide convenient medical services such as accompany during the whole treatment process, " +
      "medical visa assistance, medical record translation, pick-up and drop-off service, and medicine consultation. ",
    BetterHealthInsuranceCare:
      "“Better Health Insurance Care” is a brand we created in the field of third-party health insurance management to provide services like third-party health insurance management service, " +
      "medical network that makes payment straightforward, enterprise health management for large-enterprise users such as international and domestic insurance companies," +
      " reinsurance companies, insurance brokerage companies, insurance agency institutions, and banks.",
    LongDistanceMedicalConsultation:
      "We seek scientific, detailed second medical advice for patients, look for globally well-known medical experts that match the condition of the patient. We break the linguistic and geographical limitation," +
      " do further research on patients’ conditions and give treatment advice. ",
    noWait: "No longer need to wait to get treated",
    noExpensive: "No longer so expensive to get treated",
    noHard: "No longer so hard to get treated",
    betterTreatment: "We offer a better treatment plan",
    thirty: "More than 30",
    tenThousand: "More than 10,000",
    oneThousandSeven: "More than 1,700",
    threeThousand: "More than 3,000",
    nationalRegion: "countries and regions",
    medicalInstitution: "medical institutions around the world",
    domesticHospital: "domestic hospitals",
    medicalExperts: "medical experts",
    more: "More Services",
    // 我们的服务
    ourServices: {
      expertsOutpatient: "Expert Outpatient Service Appointment", // 专家门诊
      expertsOutpatientDetail:
        "We can make an outpatient service appointment at globally well-known medical institutions with experts from all courses and domestic" +
        " experts that at least hold positions as vice-directors at third-grade class-A hospitals." +
        " Domestic hospitals will inform you the order result in 1-3 weekdays and international ones will respond in 7 weekdays" +
        " at the earliest. ",
      expertsOperation: "Expert Operation Appointment", // 专家手术
      expertsOperationDetail:
        "We can make an operation appointment at globally well-known medical institutions with experts from all courses and domestic experts" +
        " that at least hold positions as vice-directors at third-grade class-A hospitals." +
        " Domestic hospitals will inform you the order result in 1-7 weekdays," +
        " and usually arrange your operation and hospitalization in 1-10 weekdays." +
        " International ones will respond in 7 weekdays at the earliest. ", // 专家手术
      expertWard: "Expert Ward Appointment", // 专家病房
      expertWardDetail:
        'Within the network range that our "Better medical care" covers, we can put you on priority and arrange an expert ward for you.' +
        " Domestic hospitals will inform you the order result within 1-7 days," +
        " and usually arrange your hospitalization in 1-10 weekdays." +
        " International ones will respond in 7 weekdays at the earliest. ",
      longDistance: "Long-distance Consultation", // 远程会诊
      longDistanceDetail:
        "We can make a video call or phone call appointment at globally well-known medical institutions with experts from all courses" +
        " and domestic experts that at least hold positions as vice-directors at third-grade class-A hospitals.",
      internationalMedical: "International Medical Transferal", // 国际转诊
      internationalMedicalDetail:
        "We work hand in hand with globally well-known medical institutions, create a better treatment plan according to the patient’s condition." +
        " Patients will be treated with advanced medical equipment, technology, and medicine sooner so the cure rate greatly increases, and they can be more hopeful and relieved.",
      HealthInsurance: "Health Insurance", // 健康保险
      HealthInsuranceDetail:
        "Huize insurance consultants will be your personal adviser, develop a characterized insurance plan; “Better Medical Care” preserves an amount of " +
        "“Insurance Foundation” of 2000-20000 RMB for you and will transfer it to your account after your purchase. In this way, we efficiently lower your medical cost. ",
      cancerScreening: "Cancer Screening", // 癌症筛查
      cancerScreeningDetail:
        "We will develop multiple physical examination plans so that malignant tumors and relevant risks can be efficiently screened. ",
      geneTesting: "Gene Testing", // 基因检测
      geneTestingDetail:
        "We offer detailed gene testing that assesses the conditions of patients that carry cardiovascular disease, metabolic diseases, immune-related diseases, and family diseases, " +
        "so you can know more about the risk and family history and all the other factors and manage your health with targets. "
    }
  },

  // 康保通
  BetterHealthInsuranceCare: "Better Health Insurance Care",
  // 远程会诊
  LongDistanceMedicalConsultation: "LongDistanceMedicalConsultation",
  // 服务项目
  ServiceItems: {
    name: "Service Items"
  },
  // 优诊通
  BetterMedicalCare: {
    name: "Better Medical Care",
    aboutBMC: 'About "Better Medical Care"',
    BMCDetail:
      '"Better Medical Care" is a comprehensive service that CHG INC. ' +
      "researched and developed for Chinese customers to solve the difficult situation in which the patients get poor medical and regular healthcare. It efficiently covers over 3000 well-known medical resources, including Mayo Clinic, Cancer Institute Hospital of JFCR, " +
      "Peking Union medical college Hospital, Chinese PLA General Hospital and Huashan Hospital, " +
      "and healthcare service institutions such as Ciming Checkup and Huize Insurance, providing the customers one-stop health plan and medical cases and questions from famous medical center all over the world." +
      " What's more, CHG INC. also provides a domestic and international medical green channel service," +
      " including but not limited to online and telephone medical consultation," +
      " getting medical care and treatment abroad with our accompany, medical consultations and directions," +
      " second diagnoses from both domestic and international medical experts, cancer checkup and health insurance.",
    ThereAreThree:
      "There are three versions according to the program setting: Basic, Domestic and Global.",
    moreEfficient: "More efficient and convenient service experience",
    widerMedical: "wider medical service range",
    moreAffordable: "More affordable medical mode",
    advantages: 'Advantages of "Better Medical Care"', //优诊通的优势
    hospitalsNumber: "The Number of Hospitals We Cover", // 覆盖医院数量
    hospitalsNumberDetail:
      '-"Better Medical Care" covers more than 1700 hospitals (including Hongkong, Macao, and Taiwan),' +
      " including third-grade class-A ones. It also covers more than 3000 well-known medical institutions around the world.",
    serviceRange: "Service Range and Physician Resources", // 区域范围及医生资源
    serviceRangeDetail:
      "-Our service network covers more than 30 countries and regions all over the world. The domestic one covers more than 100 cities including all the capitals and important cities." +
      ' "Better Medical Care" also possesses great medical expert resources globally——more than 3000 physicians. ',
    serviceHours: "Service Hours", // 服务时间
    serviceHoursDetail: "-We provide a sincere service 24/7.",
    respondEfficiency: "Respond Efficiency", // 响应速度
    respondEfficiencyDetail:
      "-Respond within 60 seconds at our fastest speed. The average respond speed is less than 10 minutes.",
    OurCooperation: "Corporations with Star Institutions", // 携手合作
    OurCooperationDetail:
      "-We corporate with healthcare institutions such as Ciming Checkup, Huize Insurance, and JJK and globally well-known hospitals.",
    oneStop: "One-stop Service", //一站式服务
    oneStopDetail:
      "-We produce an efficient, high-quality, affordable and thorough brand new way of getting medical care and characterized health service experience," +
      " providing excellent health protection for you and your family.",

    // 会员中心
    memberSystem: "Membership System",
    memberCenter: "VIP Center", // 会员中心
    vipBasic: " VIP Basic", // 基础版
    vipChinese: "VIP Chinese", // 华夏版
    vipGlobal: "VIP Global", // 全球版
    benefitFourFamily: "Let comforting healthcare service benefit your family",
    instructions: "VIP instructions:", // 会员说明
    // 1,2,3,4
    instructionsFirst:
      "1.\tThe yearly cost of VIP Basic is 3000 RMB. Renewals are available after one term is complete.",
    instructionsSecond:
      "2.\tDuring valid service life, VIP members and their directly-related family members (parents, spouse, and children)" +
      " can enjoy 30% off of market price if they need more service items of VIP Chinese and VIP Global.",
    instructionsThird:
      "3.\tDuring the valid service life of VIP Basic, if members upgrade their VIP to VIP Chinese, one year of VIP Basic is given for free." +
      " If they upgrade their VIP to VIP Global, two years of VIP Basic is given for free.",
    instructionsFourth:
      "4.\tVIP Basic given for free is valid after upgrading VIP Chinese of Global valid service life and cannot be converted into cash or transferred to others.",

    // 我们的服务
    ourService: "Our Service",
    // 专家门诊预约
    expertOutpatient: "Expert Outpatient Service Appointment",
    expertOutpatientDetail:
      '-Within the network range that our "Better medical care" covers,' +
      " we can make an outpatient service appointment at globally well-known" +
      " medical institutions with experts from all courses and also domestic experts that at least hold positions as vice-directors at third-grade class-A hospitals." +
      " Patients can pick the hospital and the course they want. The customer service will contact you to confirm your need within 24 hours after your order." +
      " Domestic hospitals will inform you the order result in 1-3 weekdays, and usually arrange your appointment in 1-7 weekdays." +
      " (dates will be discussed and adjusted separately under exceptional circumstances)",
    // 专家手术预约
    expertOperation: "Expert Operation Appointment",
    expertOperationDetail:
      '-Within the network range that our "Better medical care" covers, we can make an operation appointment at globally well-known medical institutions with experts from all courses and' +
      " also domestic experts that at least hold positions as vice-directors at third-grade class-A hospitals." +
      " Patients can pick the hospital and the course they want. " +
      " The customer service will contact you to confirm your need within 24 hours after your order." +
      " Domestic hospitals will inform you the order result in 1-7 weekdays," +
      " and usually arrange your operation and hospitalization in 1-10 weekdays." +
      " (dates will be discussed and adjusted separately under exceptional circumstances)",
    // 专家病房预约
    expertWard: "Expert Ward Appointment",
    expertWardDetail:
      '-Within the network range that our "Better medical care" covers, we can put you on priority and arrange an expert ward for you.' +
      " The customer service will contact you to confirm your need within 24 hours after your order." +
      " Domestic hospitals will inform you the order result within 1-7 days, and usually arrange your hospitalization in 1-10 weekdays." +
      " (dates will be discussed and adjusted separately under exceptional circumstances)",
    // 专家推荐
    expertRecommendation: "Expert Recommendation",
    expertRecommendationDetail:
      "Authorized hospitals and experts recommended (including medical consultation); CHG INC. corporates with more than 3000 globally well-known medical institutions," +
      " recommending authorized hospitals and experts all over the world for our patients so that they don’t have much difficulty getting hospitalization. At the same time," +
      " we also offer international and domestic new and special medicine recommendation in order to increase the cure rate.",
    sevenDays: "(international hospitals can reply in 7 days at the earliest)",
    chineseHospital: "VIP chinese list of hospitals", // 华夏版医院列表
    globalHospital: "VIP global list of hospitals", // 全球版医院列表

    // 远程会诊项目服务
    longDistance: "Long-distance Outpatient Appointment Service",
    pathologicalConsultation: "Pathological Consultation", // 病理咨询
    imagingConsultation: "Imaging Consultation ", // 影像咨询
    // expertRecommendation: "expert recommendation" // 专家推荐
    materialCollection: "Material Collection", // 材料收集
    appointmentConfirmation: "Appointment Confirmation ", // 确认预约
    longMedical: "Long-distance Medical  Consultation", // 远程医疗咨询
    outpatientReport: "Outpatient Report", // 会诊报告
    followUpService: "Follow-up Service", // 后续服务
    serviceIntroduction: "Service Introduction ", // 服务介绍
    // 服务介绍详情
    introduceContent:
      "We seek scientific thorough second diagnoses and treatments, breaking linguistic and geographical constraints," +
      " looking for corresponding medical experts on every case, using modern tools, having further research on patients’" +
      " conditions by doing video and phone calls, giving medical advice as a reference for patients and doctor-in-charge.",
    introduceContentFirst:
      "1.\tVIP Chinese can make phone-call appointments with doctors at third-grade class-A hospitals." +
      " Each appointment should be longer than 20 minutes. ",
    introduceContentSecond:
      "2.\tVIP Global can make video-call appointments with experts at internationally well-known medical institutions." +
      " Each appointment should be longer than 30 minutes.",

    // 癌症筛查
    cancerScreening: "Cancer Screening",
    cancerScreeningDetailTop:
      "As the average life expectancy increases and global environment deteriorates," +
      " the incidence rate of malignant tumors increases year by year." +
      " According to the World Health Organization published data (2017), there are 14 million new cancer cases," +
      " and 8 million people die of cancer every year. Since numerous patients do not check in time," +
      " resulting in that the diagnoses come out to late, curing rate severely drops, leaving little hope. ",
    cancerScreeningDetailBottom:
      "(VIP Chinese) Cancer screening check-up plan: this plan includes more than 40 check-up major items and 200 minor items," +
      " thoroughly screening common chronical diseases and basically screening cardiovascular and cerebrovascular diseases and tumors;" +
      " (VIP Global) more premium cancer screening check-up plan: this plan includes 50 check-up major items and 200 minor items," +
      " deeply screening early tumors, assessing general health condition, providing international characterized check-up service." +
      " VIP Global members can go to the U.S. (Mayo Clinic) and Japan (Cancer Institute Hospital of JFCR)" +
      " to experience a special characterized physical examination at globally well-known medical institutions.",
    notes: "P.S.:",
    psFirst:
      "1. VIP Global can choose between domestic advanced screening (limited to Beijing) and international characterized cancer screening.",
    psSecond:
      "2. The physical examination mode at international medical institutions is different from that of domestic ones." +
      " Experts at hospitals will create a characterized check-up plan according to your health condition," +
      " therefore the total fee does not stay the same. “Better Medical Care” takes care of 40000 RMB of international check-up fee at the greatest for VIP Global." +
      " The price of domestic advanced cancer screening plan is 22205 RMB." +
      " The plan includes services of 24-hours free usage of an independent ward at Ciming Oasis Health Management" +
      " Hospital as well as 5-star buffet designed by nutritionists and so on. (the prices of domestic and international screening plans are different," +
      " but neither of them can be turned into cash or returned)",
    psThird:
      "3. VIP Global needs to take care of the additional cost (such as transportation," +
      " hotel, and shopping expenses) on their way to Beijing or abroad to do their physical examination. ",
    physicalExamination: "Details of physical examination items", // 体检项目明细
    physicalExaminationLocation: "Location of physical examination", // 体检地点

    // 健康保险
    healthInsurance: "Health Insurance",
    insuranceConsultants: "Huize Insurance Consultants", // 慧择保险顾问
    insuranceConsultantsDetail:
      "Nationally accredited CFPs who have work experience of 5 years and above and broad knowledge of insurance, finance, taxation, medication, and law. ",
    characterized: "Characterized Insurance Cases", // 量身订造
    characterizedDetail:
      "Characterized cases are created based on different family factors.",
    iPay: "You consume and I’ll pay!",
    iPayDetail:
      "VIPs that purchase insurance at Huize.com can enjoy quota premium reduction and exemption we offer.",
    huizeDetail1:
      "Shenzhen Huize Insurance Brokerage Co., Ltd. was founded formally in 2006 and is one of the earliest" +
      " websites that got qualified to sell insurance online by CIRC and the founder of the third-party online insurance " +
      "service platform. After 12 years of development, Huize.com has cooperated with more than 80 insurance companies," +
      " offers nearly a thousand insurance service including health insurance, life insurance, accident insurance," +
      " travel insurance, enterprise insurance and all other kinds of insurance services to more than 30 million users. ",
    huizeDetail2:
      "Right now, domestic medical consumption has been at a high level, and many middle-class families have fell into poverty due to illness." +
      " In order to lower the medical cost to the highest extent while enjoying high-quality medical services," +
      " “Better medical care” works hand in hand with Huize.com to provide you our health insurance service." +
      " This service includes 2 modules: “insurance consultation” and “insurance foundation”." +
      " “insurance consultation” is a professional insurer consultation service provided by CHG INC.’s partner Huize.com," +
      " creating a characterized insurance scheme for you, guiding your health with a reasonable investment." +
      " “Insurance foundation” is the foundation that CHG INC. preserves for you " +
      "(VIP Chinese 2000 RMB and VIP Global 20000 RMB) to enjoy after you activate your “better medical care” product." +
      " The foundation will be one-time transferred to the bank account you provided earlier.",
    beCarefulFirst:
      "1. “Insurance Foundation” is a fixed amount of money that can only be used to purchase insurance items and cannot be turned into cash.",
    beCarefulSecond:
      "2. If the cost of the insurance you purchase is lower than the amount of “Insurance Foundation”," +
      " you can purchase other insurance products according to your own actual need.",
    beCarefulThird:
      "3. If the cost of insurance you purchase is higher than the amount of “Insurance Foundation”," +
      " you will be responsible for the excess part.",
    beCarefulFourth:
      "4. Starting from the date of activation of “Better Medical Care”," +
      " the term of validity is 1 year and the “Insurance Foundation” may only be used for insurance purchase in the first year.",

    // 基因检测
    geneticTesting: "Genetic Testing",
    geneDetection1:
      "Fully analyze the genetic code, precisely manage a healthy life!",
    geneDetection2:
      "Genes, as the most important genetic code, determine the hereditary variability of humans." +
      " Most malignant tumors, cardiovascular and cerebrovascular and familial diseases are shown in the genetic sequencing." +
      " CHG INC. works hand in hand with the most advanced medical product research development institutions to " +
      "create a characterized detailed screening plan for you to know about your disease risk and familial genetic disease history and so on. ",
    detailsTesting: "Details of testing items",

    // 更多专享服务
    moreExclusiveServices: "More exclusive services",
    accompanyDuring: "Accompany During the Whole Experience", // 全程陪着
    accompanyDuringDetail:
      "While you are getting your medical care, we have professional staff to keep you accompanied," +
      " giving you one-to-one medical guidance, including consultations before appointments, important notes of appointment," +
      " introductions of courses and procedures, line leading, making appointments and waiting in lines," +
      " and assisting describing patients’ conditions. ",
    psychologicalCounseling: "Psychological Counseling", // 心理咨询
    psychologicalCounselingDetail:
      "Certified psychologists give advice online, ease your issues, unravel your puzzled thoughts so that you can enjoy a happy life. ",
    pickUp: "Pick-up and Drop-off Service", // 接送服务
    pickUpDetail:
      "When you come to another city for medical treatment, " +
      "CHG INC will arrange shuttle buses to pick up or drop off you and book hotel for you (only for Beijing and Shanghai).",
    takeRecords: "Take your Medical Records for You", // 代取病例
    takeRecordsDetail:
      "When you are not in the area of the hospital, " +
      "we can assist to take your medical records and mail it to a second medical hospital (only for Beijing and Shanghai).",
    doctorsOnline: "Doctors from All Courses Consult Online", // 全科医生在线问诊
    doctorsOnlineDetail:
      "Doctors from all courses and different major hospitals consult online. Minor issues? Ask a doctor online." +
      " (doctors are all from third-grade class-A hospitals)",
    doctorsPhone: "Doctors from All Courses Consult on Phone", // 全科医生电话问诊
    doctorsPhoneDetail:
      "Doctors from all courses and different major hospitals provide services 7/24. Seniors can also easily find a health consultant." +
      " (Doctors are all from third-grade class-A hospitals)",
    nutritionistsOnline: "Nutritionists Consult Online", // 营养师在线
    nutritionistsOnlineDetail:
      "We can give you more reasonable suggestions on family nutritional diets, help you adjust your diet," +
      " and make your family eat in a healthier way.",
    weightOnline: "Weight Management Online Consultation", // 体重在线咨询
    weightOnlineDetail:
      "We can help manage your weight, give you characterized, " +
      "practicable health management advice based on your health data."
  },
  // 国际转诊
  InternationalReferral: {
    name: "International Referral",
    whyAbroad: "Why get your treatment abroad?",
    famousExperts: "Famous Medical Experts", // 知名医学专家
    topRankedHospitals: "Top-ranked Hospitals", // 排名顶级医院
    latestMedicalTechnology: "Latest Medical Technology", // 最新医疗技术
    highSurvival: "High Rates of Survival ", // 癌症生存率高
    newMedicine: "New Medicine Goes Public Sooner", // 新药率先上市
    advancedEquipment: "Advanced Equipment", // 先进仪器设备

    // 我们的优势
    ourAdvantages: "Our Advantages",
    ourAdvantagesDetail:
      "CHG has well-developed international team and network that will help you to get your treatment efficiently" +
      " and conveniently and enjoy sales on partial medical costs. Our service network covers more than 30 countries" +
      " and regions globally, and we have formed a deep corporation with more than 10 thousand medical institutions including" +
      " globally well-known hospitals and nearly 1 million pharmacies. ",
    efficient: "Efficient", // 高效
    healthy: "Healthy", // 健康
    safe: "Safe", // 安全
    economical: "Economical", // 节约
    guaranteed: "Guaranteed", // 保障

    // 发达国家医疗特点
    medicalParticularity: "Medical particularity of developed countries",
    US: {
      name: "The U.S.",
      topWorld: "Top comprehensive medical strength in the world",
      topFive: "Top 5-year cancer-survival rate",
      topDeveloping: "Top medication-developing capability ",
      medicalSystem: "Well-developed medical service system",
      advancedTechnology: "Advanced medical technology"
    },
    Japan: {
      name: "Japan",
      lowerCost: "Lower cost for the same medical conditions",
      technologySystem: "Well-developed medical technology system ",
      closeChina: "More convenient--close to China",
      excellentServices: "Excellent medical services",
      efficientMedical: "Efficient medical mode and detailed services"
    }
  },
  About: {
    name: "About",
    chg: "A Brief Introduction of CHG",
    chgDetail1:
      "CHG is a professional third-party health management and medical travel service enterprise which holds the value of “Customer first; justice excellence”, integrates global extraordinary medical health resources, insurance service enterprises, and insurance users. “To become the health partner that you trust the most” is a beautiful wish and goal that CHG works hard to move forward to. Right now, CHG has covered more than 8000 hospitals (including top 100 hospitals such as Mayo Clinic, Cleveland Clinic, and Massachusetts General Hospital, and domestic third-grade class-A hospitals like Peking Union medical college Hospital, Huashan Hospital, China-Japan Friendship Hospital, and Chinese PLA General Hospital), 700 thousand pharmacies, and a team of more than 1.2 million doctors in China and the U.S.",
    chgDetail2:
      "CHG has offices in Beijing, Shanghai, Shenzhen, Hefei, Huston, New York and Tokyo, provides all-around services such as medical TPA, health insurance product brokerage, international medical transferal, medical visa assistance, medical record translation, second medical advice, making appointment with hospitals and experts, accompany during treatment, arrangement of all basic necessities of life during the whole process.",
    companyCulture: "Our Culture",
    ourValue: "Our Value:\xa0" + " ",
    ourValueDetail: "Customer first, justice excellence",
    ourMission: "Our Mission:\xa0",
    ourMissionDetail: "Love and technology, guard your health",
    ourWish: "Our Wish and Goal:\xa0",
    ourWishDetail: "To become the health partner that you trust the most ",
    contactUs: "Contact Us",
    chinaAddress: "Addresses of all offices in China",
    hefei:
      "11th floor, Zhongxin Mansion, 2688th Chuang Xin Da Dao, Gaoxin District, Hefei, 230088",
    beijing:
      "6th building, Jun An Guo Ji, Ronghua South Road, Da Xing District, Beijing, 100076",
    shanghai:
      "23th floor, Bai Yu Lan Square, Dong Da Ming Road 501th, Hong Kou District, Shanghai, 200080",
    shenzhen:
      "5th floor of 3rd and 4th building, Shenzhen Dong Man Yuan, Yue Hai Road, Nan Hai Da Dao, Nanshan District, Shenzhen, 518054",
    usaAddress: "Addresses of all offices in the U.S.",
    usaAddress1: "233 Broadway Suite 2200，New York，NY 10279",
    usaAddress2: "7707 Fannin St Houston, TX 77054",
    japanAddress: "Addresses of all offices in Japan",
    japanAddress1:
      "5-17-12 Ikebukuro, Toshima-ku, Tokyo Entrepreneur Shinkansen Building 2F"
  },
  // 人才招聘
  Recruit: {
    name: "Recruit",
    joinUs: "Join Us!",
    welcomeYou: "CHG INC. welcomes you!",
    welcomeYouDetail1:
      "Love, excellence, responsibility, innovation, team-corporation, justice is the spirit of our team. " +
      "We are advancing rapidly in China. Now we sincerely welcome knowledgeable, " +
      "corporative people who have relative work experience and would take challenging tasks. " +
      "We offer brilliant career development opportunities and competitive salaries and benefits" +
      " based on the contribution and commitment employees make for our team.  ",
    welcomeYouDetail2:
      "Please take a look at the positions we offer most recently. " +
      "If you would like to apply, please send your resume in both Chinese and English and salary expectation to this" +
      " email: chg@chunhuahealth.com. We will respond to your email in time, thank you!"
  },
  openMember: {
    scanCode: "Scan code to contact customer service",
    limitedTime: "Enjoy our exclusive VIP Basic in a limited time",
    healthInsurance: "Health insurance",
    accompanyDuring: "Accompany during the whole experience",
    leftDetail:
      "Right now, domestic medical consummation level has been high, and there are numerous cases of middle-class families" +
      " falling into poverty because of the high cost of medication. To lower your cost to the maximum extent while enjoying " +
      "excellent medical services, Chunhua Health and our partner Huize.com offer a one-to-one professional insurance consultation" +
      " service worth 500 Yuan/half year. Reasonably invest for your health, and you will get an “Insurance Foundation” of 500 Yuan. " +
      "You consume and I’ll pay! VIP Basic will also get an “accompany” service worth 1000 Yuan. While you are getting your medication," +
      " professional staff will accompany you during the whole process and give you one-to-one directions. The total worth of the exclusive plan is 2000 Yuan. ",
    psychologicalCounseling: "Psychological counseling",
    cancerScreening: "Cancer Screening",
    rightDetail:
      "Purchase VIP Basic and get 2 exclusive services of certified psychologists giving advice and unravel your puzzled thoughts online." +
      " The service worth 400 Yuan. Chunhua Health and our partner Ciming Checkup will develop a cancer screening checkup plan worth" +
      " 1600 Yuan that examines regular chronic diseases and cardiovascular diseases, screens the tumors, " +
      "assess your health conditions, and make you healthier. The total value of this exclusive plan is 2000 Yuan.",
    serviceList: "VIP Basic Service List",
    makeAppointment: "Make an Appointment", //预约挂号
    makeAppointmentDetail:
      "Medical green channel that covers more than 1700 domestic hospitals and puts you on" +
      " priority to make an appointment with experts so you can get medication sooner. ",
    recommendingExperts: "Recommending Experts", // 专家推荐
    recommendingExpertsDetail:
      "We recommend global hospitals and experts and medication that fit your condition the most.",
    consultOnline: "Consult Online", // 在线问诊
    consultOnlineDetail:
      "Doctors from all courses of all big hospitals consult online. Small issues? Ask a doctor online.",
    consultPhone: "Consult on phone", // 电话问诊
    consultPhoneDetail:
      "Doctors from all courses of all big hospitals are ready to serve 7/24." +
      " Seniors can also easily have access to health consultation. ",
    weightManagement: "Weight Management", // 体重管理
    weightManagementDetail:
      "Experts will develop a characterized practicable health management plan for you.",
    nutrientConsultation: "Nutrient Consultation", // 营养师咨询
    nutrientConsultationDetail:
      "Nutrients will give advice on nutrition and diet for your family, " +
      "adjust your diet structure so you’re your family can eat in a healthier way. "
  },
  // 信息中心
  InformationCenter: {
    name: "Information Center"
  },
  // 服务案例
  ServiceCase: {
    name: "Service Case"
  },
  // 新闻动态
  NewsInformation: {
    name: "News Information"
  },
  top: "top",
  imgUrl: {
    bmcBanner: require("../images/banner-en.jpg"),
    homeBanner3: require("../images/homeimg/banner3-en.jpg"),
    bmcOurServe: require("../images/active-en.jpg"),
    bmcHexagon: require("../images/bestMedicalCare/hexagon-en.png")
  }
};
